import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import {ScheduleCalendarType} from '../../../services';
import dayjs from 'dayjs';

/**
 * returns a navigation method for navigating to the schedule week view
 */
export const useGotoSchedule = () => {
  const history = useHistory();
  return useCallback(
    (
      teamId: number,
      type: ScheduleCalendarType = 'week',
      date: Date = new Date(),
    ) => {
      history.push(
        `/schedule/${teamId}/${type}/${dayjs(date).format('YYYY-MM-DD')}`,
      );
    },
    [history],
  );
};
